import { useEffect, useState } from "react";
import { Col, Row } from "antd";
import InputComponent from "../../../components/InputComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { useDocCategoryContext } from "../../../context/DocumentCategoryContext/DocumentCategoryContext";


const Info = () => {
	const { docCategoryDetail, docCategoryForm, setDocCategoryForm } = useDocCategoryContext();
	const [categoryNoValue, setCategoryNoValue] = useState<number | undefined>(undefined);
	const [categoryNameValue, setCategoryNameValue] = useState<string>("");

	useEffect(() => {
		if (!docCategoryDetail) {
			return;
		}

		setCategoryNoValue(docCategoryDetail.categoryNo);
		setCategoryNameValue(docCategoryDetail.categoryName);
	}, [docCategoryDetail]);

	return (
		<>
			<Row gutter={20}>
				<Col span={5}>
					<InputNumberComponent
						title={"Sıra No"}
						placeholder=""
						positiveOnly
						value={categoryNoValue}
						onChange={(value) => {
							const nextValue = value === null ? undefined : Number(value);
							setCategoryNoValue(nextValue);
							setDocCategoryForm({
								...docCategoryForm,
								categoryNo: nextValue,
							});
						}}
					/>
				</Col>
				<Col span={15}>
					<InputComponent
						title={"Kategori Adı"}
						placeholder=""
						value={categoryNameValue}
						onChange={(e) => {
							const nextValue = e.target.value;
							setCategoryNameValue(nextValue);
							setDocCategoryForm({
								...docCategoryForm,
								categoryName: nextValue,
							});
						}}
					/>
				</Col>
			</Row >
		</>
	);
};

export default Info;
